import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOSchema from '@/components/base/SEOSchema';
import HeroSection from './components/HeroSection';
import RankingSection from './components/RankingSection';
import FeaturedSection from './components/FeaturedSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <SEOSchema type="WebSite" data={{
        name: '香蕉漫画',
        url: 'https://banana-comic.com',
        description: '香蕉漫画精选热门韩漫、日漫、国漫分类推荐，涵盖恋爱、奇幻、热血等所有风格，为漫迷提供高清漫画免费在线阅读和人气排行榜。',
        inLanguage: 'zh-CN',
      }} />
      <SEOSchema type="Organization" data={{
        name: '香蕉漫画',
        url: 'https://banana-comic.com',
        description: '香蕉漫画精选热门韩漫、日漫、国漫分类推荐平台',
        sameAs: ['https://weibo.com/', 'https://weixin.qq.com/'],
      }} />

      <Navbar />
      <main>
        <HeroSection />
        <FeaturedSection />
        <RankingSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}